import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';

export interface JudgementOnMeritsMotifRecapProps {
  intl: IntlShape;
  motifs: (string | undefined)[];
}

export const JudgementOnMeritsMotifRecap: React.FC<JudgementOnMeritsMotifRecapProps> = ({
  motifs,
  ...props
}): JSX.Element => {
  motifs = motifs.reverse();
  const [instruction, ...newMotifs] = motifs;
  return (
    <section className="judgement-on-merits-contestation-container">
      <h4 className="contestation-container-title">
        {translate(messages.decision, props)}
      </h4>
      <article className="contestation-status">
        <span className="contestation-sub-bloc-title">
          {translate(messages.status, props)}
        </span>
        <span>{translate(messages.challenged, props)}</span>
        <div className="contestation-reason">
          <span className="contestation-sub-bloc-title">
            {translate(messages.contestationReason, props)}
          </span>
          {newMotifs.length === 1 ? <span>{newMotifs[0]}</span> : ''}
        </div>
        {newMotifs.length > 1 &&
          newMotifs.map((motif: any, index) => {
            return (
              <div className="contestation-reason">
                <span>{motif}</span>
              </div>
            );
          })}
        {instruction !== '' && (
          <>
            <div className="contestation-reason">
              <span className="contestation-sub-bloc-title">
                {translate(messages.contestationInstruction, props)}
              </span>
            </div>

            <div className="contestation-reason">
              <span>{instruction}</span>
            </div>
          </>
        )}
      </article>
    </section>
  );
};

export default injectIntl(JudgementOnMeritsMotifRecap);
